import { useEffect, useCallback } from 'react';
import { dispatcher } from 'dispatcher';
import { ILaunchGameEventData } from 'js/hooks/gameLauncher/types';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

export const useLegacyTrackGameLaunchListener = () => {
    const trackGameLaunch = useCallback((eventData: ILaunchGameEventData) => {
        publicEventsAPIService.trigger('game-launch-event', eventData);
    }, []);

    useEffect(() => {
        dispatcher.listen('game-launch-event', trackGameLaunch);

        return () => {
            dispatcher.removeListener('game-launch-event', trackGameLaunch);
        };
    }, [trackGameLaunch]);
};
